
<script>

    import CheckoutAddressForm from '../../components/checkout/CheckoutAddressForm'
    import AddressSelectModal from '../../components/AddressSelectModal'
    import Cart from '../../components/Cart.vue'
    import LoadingView from '../LoadingView'
    import User from '../../models/User'
    import TooltipQuestion from "../TooltipQuestion"
    import OrderHistory from "../../models/OrderHistory"
    import CheckoutForms from "./CheckoutForms"
    import UserAddress from "../../models/UserAddress"

    export default {
        name: 'checkout',

        data () {
            return {
                user: new User(),
                orderHistoryForm: new OrderHistory(),
                oldData: [], // 前回入力したデータ
                errors: [], // エラーメッセージ格納
                sendOrderState: false,
                isCartInCharterOnly: false, // チャーター便のみのアイテムがカートに入っているか
            }
        },

        props: {
            data: {},
        },

        computed: {
        },

        mounted() {
            this.user = new User({...eval(this.data).user})
            this.oldData = eval(this.data).oldData
            this.isCartInCharterOnly = eval(this.data).isCartInCharterOnly
            this.errors = eval(this.data).errors

            this.setOrderData()
        },

        methods: {

            setOrderData() {
                let _userAddress = new UserAddress({...this.user.userAddress})
                _userAddress.form.errors.set({...this.errors})
                let _userDeliveryAddress = this.user.defaultDeliveryAddress
                if (this.oldData.order_delivery_address_id) {
                    _userDeliveryAddress = this.user.getOldAddress(this.oldData.order_delivery_address_id)
                }
                let oh = new OrderHistory({
                    user: {...this.user},
                    orderUserAddress: _userAddress,
                    orderDeliveryAddress: _userDeliveryAddress,
                    firstName: this.user.firstName,
                    familyName: this.user.familyName,
                    userPhone: this.user.tel,
                    orderCompanyName: this.user.company,
                })

                oh.form.errors.set({...this.errors})
                oh.setOldData(this.oldData)
                oh.dateFormatConvert()
                this.updateForm(oh)
            },

            updateForm(val) {
                this.orderHistoryForm = new OrderHistory({...val})
            },

            sendOrder() {
                document.orderForm.action = '/checkoutConfirm'
                document.orderForm.submit()
            },

            onStockCheck() {
                document.orderForm.action = '/checkoutConfirm'
                document.orderForm['is_stock_check_only'].value = true
                document.orderForm.submit()
            }
        },

        components: {
            CheckoutAddressForm,
            AddressSelectModal,
            Cart,
            LoadingView,
            TooltipQuestion,
            CheckoutForms,
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/checkout/Checkout.vue